import { z } from 'zod';

// Schema operatore — anagrafica per dropdown MPG/CON.
// Vedi prisma model Operator.

export const operatorResponseSchema = z.object({
  id: z.string(),
  code: z.string(),
  fullName: z.string(),
  active: z.boolean(),
  hiredAt: z.string().nullable(),
  terminatedAt: z.string().nullable(),
  notes: z.string().nullable(),
  isLegacy: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type OperatorResponse = z.infer<typeof operatorResponseSchema>;

export const operatorListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(500).default(100),
  search: z.string().trim().min(1).max(120).optional(),
  active: z.coerce.boolean().optional(),
  includeLegacy: z.coerce.boolean().default(true),
});
export type OperatorListQuery = z.infer<typeof operatorListQuerySchema>;

export const operatorListResponseSchema = z.object({
  items: z.array(operatorResponseSchema),
  total: z.number().int().nonnegative(),
  page: z.number().int().positive(),
  pageSize: z.number().int().positive(),
});
export type OperatorListResponse = z.infer<typeof operatorListResponseSchema>;

export const operatorCreateRequestSchema = z.object({
  code: z.string().trim().min(1).max(32),
  fullName: z.string().trim().min(1).max(120),
  active: z.boolean().default(true),
  hiredAt: z.coerce.date().optional().nullable(),
  notes: z.string().trim().max(500).optional().nullable(),
});
export type OperatorCreateRequest = z.infer<typeof operatorCreateRequestSchema>;

export const operatorUpdateRequestSchema = z.object({
  code: z.string().trim().min(1).max(32).optional(),
  fullName: z.string().trim().min(1).max(120).optional(),
  active: z.boolean().optional(),
  hiredAt: z.coerce.date().optional().nullable(),
  terminatedAt: z.coerce.date().optional().nullable(),
  notes: z.string().trim().max(500).optional().nullable(),
});
export type OperatorUpdateRequest = z.infer<typeof operatorUpdateRequestSchema>;
